import { render, staticRenderFns } from "./ResultRisk2Manage.vue?vue&type=template&id=dbdf2636&scoped=true&"
import script from "./ResultRisk2Manage.vue?vue&type=script&lang=js&"
export * from "./ResultRisk2Manage.vue?vue&type=script&lang=js&"
import style0 from "./ResultRisk2Manage.vue?vue&type=style&index=0&id=dbdf2636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdf2636",
  null
  
)

export default component.exports